import React, { useState } from "react";
import { Link } from "gatsby";
import Image from "gatsby-image";
import ImageViewer from "../../components/ImageViewer";
import "./index.css";

const CinemaItemImage = ({ image, allImages }) => {
  const [open, setOpen] = useState(false);
  let index = 0;
  for (var i = 0; i < allImages.length; i++) {
    if (image === allImages[i]) {
      index = i;
      break;
    }
  }
  console.log("here");
  return (
    <div
      className="cinemaitem-image"
      onClick={() => setOpen(!open)}
      key={Math.random()}
    >
      <Image fluid={image.node.fluid} style={{ height: `100%` }} />
      <ImageViewer
        isOpen={open}
        onClose={() => setOpen(false)}
        allImages={allImages}
        currentPosition={index}
      >
        {image}
      </ImageViewer>
    </div>
  );
};

export default CinemaItemImage;
